<template>
    <tea-main @back="goBack" width="1000px">
        <template slot="nav">
            <div class="qualificationNav">
                <div class="main_wrap">
                    <!-- <div class="left">
                        <a v-for="(status, index) in statusList" :key="index"
                           :class="{'btn': true, active: index == idx}"
                           @click="switchTab(index,status.type)">{{status.name}}</a>
                    </div> -->
                    <div class="left">
                        <p class="btn " @click="jumpTo('/system/blacklist')">处罚人员列表</p>
                        <p class="btn" @click="jumpTo('/system/punishPeopleAudit')" v-if="!isFive">
                          <el-badge :is-dot="Number(punishPeople) > 0">待审核</el-badge>
                        </p>
                        <p class="btn active" >
                          <el-badge :is-dot="Number(peopleAppeal) > 0">申诉处理</el-badge>
                        </p>
                        
                    </div>
                    
                </div>
            </div>
        </template>
        <template slot="main">
            <div class="qualificationMain">
                <div class="searchWrap">
                    <div class="search">
                        <div class="leisureBtn">
                            <select v-model="search.status"
                                    @change="changeUserType()">
                                <option value="">全部状态</option>
                                <option v-for="(item, index) in statusList"
                                        :key="index"
                                        :value="item.type">{{ item.name }}
                                </option>
                            </select>
                        </div>
                        <div class="wrap">
                            <input v-model.lazy="search.keywords"
                                   type="text"
                                   placeholder="请输入搜索内容"
                                   @keyup.enter="getRequest">
                            <div v-show="search.keywords!=''"
                                 class="close"
                                 @click="hideIcon">
                                <v-icon name="regular/times-circle"
                                        scale="1.2"></v-icon>
                            </div>
                            <div class="searchBtn"
                                 @click="getRequest">搜索
                            </div>
                        </div>
                    </div>
                </div>
                <yioks-loading v-show="isLoading"></yioks-loading>
                <template v-if="!isLoading">
                    <template v-if="showList">
                        <div class="table">
                            <div class="thead">
                                <div class="tr">
                                    <div class="th index"><strong>序号</strong></div>
                                    <div class="th name"><strong>姓名/详情</strong></div>
                                    <div class="th id_number"><strong>身份证有效证件号</strong></div>
                                    <div class="th mobile_phone"><strong>手机号</strong></div>
                                    <div class="th create_time"><strong>上传时间</strong></div>
                                    <div class="th status" v-if="!search.status"><strong>审核状态</strong></div>
                                    <div class="th opt"><strong>操作</strong></div>
                                </div>
                            </div>
                            <div class="scrollArea" v-if="showList">
                                <vue-scroll :ops="ops" ref="vs">
                                    <div class="tbodyWrap">
                                        <div class="tbody">
                                            <div class="tr"
                                                 v-for="(item, index) in list"
                                                 :key="index">
                                                <div class="td index">
                                                    <p>{{ index+1 }}</p>
                                                </div>
                                                <div class="td name">
                                                    <p class="showRecord" >
                                                        <span v-if="item.record_tags && item.record_tags!='[]'">
                                                            <el-tooltip class="item" effect="light" :content="getTags(item.record_tags)" placement="top-start">
                                                              <v-icon name="tags"></v-icon>
                                                            </el-tooltip>
                                                        </span>
                                                        <span @click="lookOver(item.id_number,item.the_query_code)">{{ item.name }}</span> </p>
                                                </div>
                                                <div class="td id_number">
                                                    <p>{{ item.id_number||"--" }}</p>
                                                </div>
                                              <div class="td mobile_phone">
                                                <p>{{item.mobile_phone || '--'}}</p>
                                              </div>
                                                <div class="td create_time">
                                                    <p>{{item.create_time | time(false)}}</p>
                                                </div>
                                                <div class="td status" v-if="!search.status">
                                                    <p>{{item.status |auditStatus}}</p>
                                                </div>
                                                <div class="td opt">
                                                    <span @click="verify(item.appeal_id,index)" v-if="item.status==='audit'" class="review">审核</span>
                                                    <span @click="lookOver(item.id_number,item.the_query_code)" v-else>查看</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </vue-scroll>
                            </div>
                        </div>
                        <div id="paging">
                            <yioks-paging :paging="paging"
                                          @goto-page="gotoPage($event)"></yioks-paging>
                        </div>
                    </template>
                    <yioks-empty v-show="showEmpty"></yioks-empty>

                </template>
                <template v-if="verifyFlag">
                    <yioks-verify :flag="verifyFlag"
                                  :verifyBtn="true"
                                  :holderText="`如审核拒绝，可在此输入理由`"
                                  @hideVerify="hideVerifyDialog"></yioks-verify>
                </template>
            </div>
        </template>
    </tea-main>
</template>

<script>
    import {peopleAppealList,peopleAppealAudit} from "@/api/system_manager/api";
    import ops from '@/assets/js/vuescrollOption';
    import fiveMixins from "@/minix/fiveMixins";
    import 'vue-awesome/icons/tags.js'
    export default {
        name: "appealList",
      mixins: [fiveMixins],
        data() {
            return {
                ops: ops(),
                search_time:[],
                idx:0,
                appeal_id:'',
                index:0,
                verifyFlag:false,
                id_number:'',
                the_query_code:'',
                statusList:[
                    {
                    name:'待审核',
                    type:'audit'
                },
                    {
                        name:'已通过',
                        type:'pass'
                    },{
                        name:'已拒绝',
                        type:'refused'
                    },
                //     {
                //     name:'全部',
                //     type:''
                //   }
                ],
                isLoading: true,
                showList: false,
                showEmpty: false,
                list: [],
                page: 1,
                paging: {
                    start: 0,
                    prePage: 1, // 一页多少条数据
                    total: 0, // 总页数
                    size: 3, // 页码显示限制
                    last: true, // 尾页
                    next: true, // 下一页
                    first: true, // 首页
                    previous: true, // 上一页
                    jump: true
                },
                search: {
                    keywords:'',
                    status:''
                },
            }
        },
      computed: {
        peopleAppeal(){
          return this.$store.state.peopleAppeal
        },
        punishPeople(){
          return this.$store.state.punishPeople
        }
      },
        components: {
            "tea-main": () => import("@/components/LayOut/Common/up-down"),
            "yioks-paging": () => import("@/components/Pagination/Page"),
            "yioks-empty": () => import("@/components/Tips/Empty"),
            "v-icon": () => import("vue-awesome/components/Icon"),
            "yioks-loading": () => import("@/components/Loading/Loading"),
            "yioks-verify": () => import("@/components/Tips/verify-appeal"),
        },
        created() {
            this.setData();
            this.request();
        },
        filters: {
            auditStatus(status){
              switch (status) {
                  case 'audit' : status='待审核';break;
                  case 'pass' : status='通过';break;
                  case 'refused' : status='拒绝';break;
                  default:status='';break
              }
              return status
            }
        },
        methods: {
            setData(){
                // console.log(this.$route.query);
                const {page,keywords, idx,status} = this.$route.query;
                // idx &&(this.idx=Number(idx));
                // if (!status){
                //     if (Number(this.idx)===0){
                //         this.$set(this.search, "status", 'audit')
                //     } else if (Number(this.idx)===this.statusList.length-1) {
                //         this.$set(this.search, "status", '')
                //     }
                // }else{
                //     this.$set(this.search, "status", status)
                // }
                page && (this.page = page);
                keywords && (this.$set(this.search, "keywords", keywords));
                status && (this.$set(this.search, "status", status));
            },
            goBack() {
                this.$router.push('sm');;
            },
            request() {
                this.isLoading = true;
              peopleAppealList({"page": this.page, ...this.search})
                    .then(res=>{
                        if (res.data.status===0){
                            const {result} = res.data;
                            this.$set(this.paging, "prePage", result.page.page_size);
                            this.$set(this.paging, "total", result.page.total_row);
                            this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
                            this.list = result.list;
                            this.showList = result.list.length > 0;
                            this.showEmpty = !this.showList;
                            this.isLoading = false;
                        } else{
                            this.$message.error(res.data.msg);
                            this.isLoading = false;
                        }
                    })
                    .catch(err=>{
                        this.isLoading = false;
                        console.error(err);
                    })
            },
            hideIcon() {
                this.$set(this.search, "keywords", "");
                this.getRequest();
            },
            hideTimeIcon(){
                this.search_time='';
                this.$set(this.search, "start_date", "");
                this.$set(this.search, "end_date", "");
                this.getRequest();
            },
            changeUserType(){
              this.changeQuery(true)
            },
            changeCheck(checkedEdu){
              if(checkedEdu){
                this.search.checkedEdu = true;
              }else{
                this.search.checkedEdu = false;
              }
              this.changeQuery(true)
            },
            getRequest() {
                this.changeQuery(true);
            },
            gotoPage: function (start) {
                this.page = parseInt(start / this.paging.prePage) + 1;
                this.changeQuery(false);
                this.$refs['vs'].scrollTo({ y: 0 });
            },
            changeQuery(flag) {
                flag && (this.page = 1);
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.page,
                        idx: this.idx,
                        keywords: this.search.keywords,
                        status:this.search.status
                    }
                });
                this.request();
            },
            lookOver(id_number,code) {
                this.$router.push({path: 'peopleAppealInfo', query: {id_number: id_number,the_query_code:code}});
            },
            getTime(time) {
                return time.map((t) => {
                    const timestamp = new Date(t).getTime();
                    return this.$yioks.time(timestamp, false);
                });
            },
            switchTab(index,type){
                if (index === this.idx) {
                    return;
                }
                this.showEmpty = false;
                this.$set(this.search, "keywords", "");
                this.$set(this.search, "status",type);
                this.idx = index;
                this.changeQuery(true);
            },
            verify(appeal_id,index) {
                this.verifyFlag = true;
                this.appeal_id=appeal_id;
                this.index=index
            },
            hideVerifyDialog(bool, params, msg) {
                if (bool) {
                  peopleAppealAudit({
                        appeal_id:this.appeal_id,
                        status:params,
                        msg_info:msg
                    }).then(res=>{
                        if (Number(res.data.status)===0) {
                            switch (params) {
                                case 'Y':this.list[this.index].status='pass';break;
                                case 'N':this.list[this.index].status='refused';break
                            }
                            this.$message.success('申诉信息审核成功');
                            this.verifyFlag = false;
                        }else{
                            this.$message.error(res.data.msg)
                            this.verifyFlag = false;
                        }
                    }).catch(err=>{
                        console.log(err);
                        this.verifyFlag = false;
                    })
                }else{
                    this.verifyFlag = false;
                }
            },
            getTags(tags){
                if (tags){
                    return (JSON.parse(tags)).join(',')
                }else{
                    return ''
                }
            },
            
            jumpTo(path) {
                this.$router.push({
                    path: path,
                })
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/assets/css/variable";
    @import "~@/assets/css/mixin";
    @import "~@/assets/css/nav_filter";
    .qualificationNav, .qualificationMain {
        flex: 1 1 auto;
        height: 100%;
    }
    .qualificationNav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 12px 0 0;
        font-size: $font_size_big;
        .main_wrap{
            display: flex
            flex: 1
            justify-content: space-between
            align-items: center
            .left, .right{
                display: flex
                align-items: center
                .btn{
                    padding: 5px 15px;
                    cursor: pointer;
                    &.active{
                        background-color: $color_suc;
                    }
                    &+.btn{
                        margin-left: 10px
                    }
                }
            }

        }


    }

    .qualificationMain {
        width: 100%;
        padding: 25px 0 0;
        background-color: $block_bg_color_base;
        .searchWrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            margin: 0 40px;
            .search {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .wrap {
                    height: 100%;
                    display flex
                    position: relative;
                    input {
                        width: 220px;
                        height: 100%;
                        padding: 0 20px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        outline: none;
                    }
                    .close {
                        position: absolute;
                        right: 95px;
                        top: 10px;
                        color: $color_info;
                        cursor: pointer;
                    }
                    .searchBtn {
                        width: 90px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 20px;
                        background-color: $color_suc;
                        cursor: pointer;

                    }
                }
                .leisureBtn{
                    position relative
                    display flex
                    height 100%
                    .close {
                        position: absolute;
                        right: 275px;
                        top: 10px;
                        color: $color_info;
                        cursor: pointer;
                    }
                    .timePicker{
                        border-radius 0
                        width 255px
                        margin-right 20px
                        span{
                            padding 0
                        }
                    }
                    select {
                        width: 150px;
                         height: 100%;
                        padding: 0 10px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        cursor pointer
                        outline: none;
                        &+select {
                            margin-left 15px
                        }
                    }
                }
            }
        }
        .table {
            width: 100%;
            margin: 30px 0 0;
            .thead, .tbody {
                border: 1px solid $color_white;
            }
            .thead {
                margin: 0 40px;
                .tr {
                    height: 45px;
                    display: flex;
                }
            }
            .scrollArea {
                height: 401px;
            }
            .tbodyWrap {
                display block
                margin-bottom 10px
                // padding: 0 40px;
            }
            .tbody {
                display block
                margin-left auto
                margin-right auto
                width: 920px;
                max-width: 920px;
                border-top: none;
                border-bottom: none;
                .tr {
                    height: 49px;
                    display: flex;
                    border-bottom: 1px solid $color_white;
                }
            }
            .th, .td {
                height: 100%;
                flex: 1 1 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
                border-right: 1px solid $color_white;
            }
            .th:last-child, .td:last-child {
                border-right: none;
            }
            .td:last-child {
                color: $color_suc;
                user-select: none;
            }
            .td {
                p {
                    over_hide();
                }
                .showRecord{
                    color: $color_suc;
                    user-select: none;
                    cursor pointer
                }
            }
            .index {
                width: 6%;
            }
            .name {
                width: 18%;
            }
            .mobile_phone {
                width: 12%;
            }
            .id_number {
                width: 20%;
            }
            .create_time {
                width: 12%;
            }
            .status {
                width: 10%;
            }
            .opt {
                width: 10%;
                span{
                    cursor: pointer;
                    color: $color_suc;
                }
                .review{
                    padding: 5px 15px;
                    background-color: #4cd964;
                    border: none;
                    outline: none;
                    color #fff
                }
            }
        }
        #paging {
            width: 100%;
            height: 77px;
        }
    }
</style>

<style lang="stylus" >
    .qualificationMain{
        .el-date-editor .el-range-separator{
            padding 0
        }
        .__vuescroll .__view{
            min-height 96%
        }
    }
</style>
